document.addEventListener("DOMContentLoaded", function () {

  const picker = document.querySelector("variant-picker");

  /* 🚫 se não existir picker ou tiver apenas 1 variante, não roda o script */
  if (!picker || picker.querySelectorAll('input[type="radio"]').length <= 1) {
    return;
  }

  /* remove ?variant= */
  if (location.search.includes("variant=")) {
    const newUrl = location.pathname + location.hash;
    history.replaceState({}, "", newUrl);
  }

  function setAddToCartState(form, enabled, label) {
    const btn = form.querySelector("[name='add']");
    if (!btn) return;

    btn.disabled = !enabled;

    const text = btn.querySelector(".add-to-cart-text") || btn;
    if (label) text.textContent = label;
  }

  function resetVariantPicker(form) {

    const picker = form.querySelector("variant-picker");
    if (!picker) return;

    const radios = picker.querySelectorAll('input[type="radio"]');

    picker.querySelectorAll(".is-selected, .selected, [data-selected]").forEach(el => {
      el.classList.remove("is-selected", "selected");
      el.removeAttribute("data-selected");
    });

    radios.forEach(r => {
      r.checked = false;
      r.removeAttribute("checked");
    });

    picker.querySelectorAll("select").forEach(select => {
      select.selectedIndex = 0;
    });

    const variantInput = form.querySelector('[name="id"]');
    if (variantInput) variantInput.value = "";

    picker.removeAttribute("data-variant-id");

  }

  function initForm(form) {

    setAddToCartState(form, false, "Selecione uma opção");

    setTimeout(() => {
      resetVariantPicker(form);
    }, 1200);

  }

  document.querySelectorAll("form[action*='/cart/add']").forEach(initForm);

  document.addEventListener("shopify:section:load", function (event) {
    event.target
      .querySelectorAll("form[action*='/cart/add']")
      .forEach(initForm);
  });

});


document.addEventListener("DOMContentLoaded", () => {

  const picker = document.querySelector("variant-picker");

  /* 🚫 não roda se tiver apenas 1 variante */
  if (!picker || picker.querySelectorAll('input[type="radio"]').length <= 1) {
    return;
  }

  const first = picker.querySelector('input[type="radio"]:checked');
  if (!first) return;

  const label = first.closest("label");

  first.checked = false;
  label?.classList.remove("selected","is-selected");
  label?.removeAttribute("data-selected");

});








// SCRIPT PARA TESTAR DEPOIS 

// Objetivo do script:

// Se o produto tiver apenas 1 opção real (ex: tamanho único ou uma única cor)

// Esconder o seletor de variantes

// Liberar o botão "Adicionar ao carrinho"

// Sem quebrar o JS do tema Atelier.




// document.addEventListener("DOMContentLoaded", () => {

//   const picker = document.querySelector("variant-picker");
//   const form = document.querySelector("form[action*='/cart/add']");
//   const button = form?.querySelector("[name='add']");

//   if (!picker || !form || !button) return;

//   const radios = picker.querySelectorAll('input[type="radio"]');
//   const selects = picker.querySelectorAll("select");

//   let totalOptions = 0;

//   radios.forEach(r => totalOptions++);
//   selects.forEach(s => totalOptions++);

//   /* se só existir uma opção real */
//   if (totalOptions <= 1) {

//     /* esconde seletor */
//     picker.style.display = "none";

//     /* libera botão */
//     button.disabled = false;

//     const text = button.querySelector(".add-to-cart-text");
//     if (text) text.textContent = "Adicionar ao carrinho";

//   }

// });